import React, { Component } from 'react';
import ProductImageThumb from './image-thumbnail';

class ThumbnailList extends Component {
    render() {
        const imagesMarkup = this.props.images.length > 1 && this.props.images.map((image, idx) => (
            <ProductImageThumb
                key={`thumbnail-image-${idx}`}
                imageUrl={image}
                onClickThumbnail={this.props.onClickThumbnail}
                imageNo={idx}
            />
        ));

        return <div>{imagesMarkup}</div>;
    }
}

export default ThumbnailList;



/** WEBPACK FOOTER **
 ** ./src/components/product/thumbnail-list.jsx
 **/